<div class="form-container">

    <form>

        <div class="mce-form-section">

            <div class="mce-form-section-title">User Management</div>

            <div class="mce-form-field-group">
                <mat-form-field class="w-2/4">
                    <mat-label>search users</mat-label>
                    <input type="text"
                           placeholder="enter a string to search for"
                           matInput
                           [formField]="form.searchString"
                           [matAutocomplete]="auto">
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="optionSelected($event)">
                        @for (option of options() | async; track option) {
                        <mat-option [value]="option.value">{{option.label}}</mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>

            </div>

        </div>


        @if (viewState().showUser) {
        <div class="grid grid-cols-2 gap-4">

            <div class="max-h-[750px] min-w-0 overflow-auto">
                <pre>{{viewState().user | json}}</pre>
                <pre>{{viewState().roles | json}}</pre>
            </div>

            <div class="flex flex-col gap-4">
                <mce-support-user-stripe [userUid]="viewState().user.uid ?? ''"
                                         [subscription]="viewState().user.subscription"
                                         (budgetUpdated)="budgetUpdated($event)">
                </mce-support-user-stripe>


                <mat-card appearance="outlined">
                    <mat-card-content class="mt-4">
                        <div>
                            <div class="mb-4 flex gap-4">
                                <button matButton="filled" color="primary" type="button"
                                        [disabled]="!viewState().canResetFreeTier"
                                        (click)="resetFreeTier()">
                                    Reset Free Tier
                                </button>

                                <button matButton="filled" color="primary" type="button"
                                        (click)="viewMeterEvents()">
                                    View Meter Events
                                </button>
                            </div>

                            <div class="flex gap-4">

                                <div>
                                    <mat-form-field class="w-72">
                                        <mat-label>user email</mat-label>
                                        <input matInput placeholder="enter a new email addrress"
                                               [formField]="form.newEmail" />

                                        @for (error of form.newEmail().errors(); track error.kind ) {
                                        <mat-error>
                                            {{ error.message }}
                                        </mat-error>
                                        }
                                    </mat-form-field>
                                </div>

                                <div>
                                    <button matButton="filled" color="primary" type="button"
                                            [disabled]="!form.newEmail().valid()"
                                            (click)="changeEmail()">
                                        change email
                                    </button>
                                </div>
                            </div>

                        </div>


                    </mat-card-content>
                </mat-card>


                <mat-card appearance="outlined">
                    <mat-card-content class="mt-4">

                        <div class="max-h-[650px] min-w-0 overflow-auto">

                            <h2 class="mt-4 mb-2 font-medium">Projects</h2>

                            @for (project of projects(); track project) {
                            <p>
                                {{project.projectNumber}}: {{project.projectName}}

                                <button matIconButton type="button"
                                        matTooltip="View cables for this project."
                                        [attr.aria-label]="'View cables for project ' + (project.projectNumber ?? project.uid ?? '')"
                                        [routerLink]="['/cables', project.uid]"
                                        [disabled]="!project.uid">
                                    <mat-icon>group_work</mat-icon>
                                </button>

                                <button matIconButton type="button"
                                        matTooltip="Reference {{project.uid}}. Click to copy reference to clipboard."
                                        [cdkCopyToClipboard]="project.uid ?? ''">
                                    <mat-icon>chat_info</mat-icon>
                                </button>





                            </p>
                            }
                        </div>

                    </mat-card-content>
                </mat-card>





            </div>

            </div>

        }

    </form>

    @if (viewState().showSpinner) {
    <div class="spinner">
        <mat-spinner test-id="spinner"></mat-spinner>
    </div>
    }

</div>





